module.exports = __webpack_public_path__ + "static/media/North_Brabant.1e170cf3.jpg";